
export const suklMedicationRecordFrag = `
    id
    date
    atc
    code
    name
    packaging
    amount
    dosing
    prescribedByName
    prescribedByPhone
    magistraliter {
        preparationProcedure
        administrationRoute
        form
        ingredients {
            name
            amount
            unit
            substanceCode
            registeredMedicationCode
        }
    }
`;

export const suklMedicationRecordListFrag = `
    records {
        ${suklMedicationRecordFrag}
    }
`;
